<template>
  <div>
    <el-card class="box-card">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="资源名称" prop="parentId" class="form-bottom">
              <el-cascader
                v-model="searchForm.parentId"
                :options="treeParams"
                :props="treeParamsProps"
                filterable
                clearable
                :show-all-levels="false"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="功能" prop="functions" class="form-bottom">
              <el-select
                v-model="searchForm.functions"
                placeholder="请输入功能"
              >
                <el-option
                  v-for="item in functions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="资源路径" prop="url" class="form-bottom">
              <el-input
                v-model="searchForm.url"
                placeholder="请输入资源路径"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button
              :size="buttonSize"
              type="primary"
              @click="
                page.pageNumber = 1
                pageList()
              "
              icon="el-icon-search"
              >查询</el-button
            >
            <el-button
              v-auth="'/resource/pageListreset'"
              :size="buttonSize"
              type="primary"
              @click="reset"
              icon="el-icon-refresh"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            v-auth="'/resource/addResource'"
            :size="buttonSize"
            type="primary"
            @click="addBtn()"
            icon="el-icon-plus"
          ></el-button>
          <el-button
            v-auth="'/resource/deleteResource'"
            :size="buttonSize"
            type="danger"
            @click="batchDeleteResource"
            icon="el-icon-minus"
            >批量删除</el-button
          >
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button
            v-auth="'/resource/importData'"
            :size="buttonSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
            >导入</el-button
          >
          <el-button
            v-auth="'/resource/exportExcel'"
            :size="buttonSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
            >导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="tableLoading"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="module" label="模块"></el-table-column>
        <el-table-column prop="name" label="资源名称">
          <template slot-scope="scope">
            <el-button @click="changePid(scope.row.id)" type="text">{{
              scope.row.name
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="functions" label="功能"></el-table-column>
        <el-table-column prop="url" label="资源路径"></el-table-column>
        <el-table-column prop="icon" label="图标">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
        <el-table-column prop="sequence" label="排序"></el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span
                v-auth="'/resource/updateResource'"
                @click=";(selection = scope.row.id), (editFormVisible = true)"
                >编辑</span
              >
              <span
                @click="deleteResource(scope.row)"
                v-auth="'/resource/delResource'"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!tableLoading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" left>
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-form-item label="父级资源" prop="parentId">
          <el-cascader
            v-model="addForm.parentId"
            :options="treeParams"
            :props="treeParamsProps"
            filterable
            clearable
            ref="elAddCascader"
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="功能" prop="functions">
          <el-select v-model="addForm.functions" placeholder="请输入功能">
            <el-option
              v-for="item in functions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入资源名称"
            auto-complete="off"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源路径" prop="url">
          <el-input
            v-model="addForm.url"
            placeholder="请输入资源路径"
            auto-complete="off"
            maxlength="512"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="图标"
          prop="icon"
          style="height: 200px; overflow: auto"
          v-if="addForm.functions != '按钮'"
        >
          <i
            v-for="(icon, index) in iconArray"
            :key="index"
            :class="icon"
            :style="
              addForm.icon == icon
                ? 'border: 1px solid #111;font-size: 20px;'
                : 'border: 0px;font-size: 20px;'
            "
            @click="selectIcon('add', $event)"
          ></i>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="sequence"
          v-if="addForm.functions != '按钮'"
        >
          <el-input
            type="number"
            v-model="addForm.sequence"
            placeholder="请输入排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="addResource"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="父级资源" prop="parentId">
          <el-cascader
            v-model="editForm.parentId"
            :options="treeParams"
            :props="treeParamsProps"
            filterable
            ref="elEditCascader"
            clearable
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="功能" prop="functions">
          <el-select v-model="editForm.functions" placeholder="请输入功能">
            <el-option
              v-for="item in functions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入资源名称"
            auto-complete="off"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源路径" prop="url">
          <el-input
            v-model="editForm.url"
            placeholder="请输入资源路径"
            auto-complete="off"
            maxlength="512"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="图标"
          prop="icon"
          style="height: 200px; overflow: auto"
          v-if="editForm.functions != '按钮'"
        >
          <i
            v-for="(icon, index) in iconArray"
            :key="index"
            :class="icon"
            :style="
              editForm.icon == icon
                ? 'border: 1px solid #111;font-size: 20px;'
                : 'border: 0px;font-size: 20px;'
            "
            @click="selectIcon('edit', $event)"
          ></i>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="sequence"
          v-if="editForm.functions != '按钮'"
        >
          <el-input
            type="number"
            v-model="editForm.sequence"
            placeholder="请输入排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="updateResource"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="buttonSize" type="primary" icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传xls、xlsx文件，且不超过1024kb
        </div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="module" label="模块"></el-table-column>
        <el-table-column prop="name" label="资源名称"></el-table-column>
        <el-table-column prop="functions" label="功能"></el-table-column>
        <el-table-column prop="url" label="资源路径"></el-table-column>
        <el-table-column prop="icon" label="图标"></el-table-column>
        <el-table-column prop="sequence" label="排序"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableLoading: false,
      iconArray: [
        "el-icon-third-zhtn",
        "el-icon-third-commodity",
        "el-icon-third-int",
        "el-icon-third-tools",
        "el-icon-third-supply",
        "el-icon-third-questions",
        "el-icon-third-qianniudaidise",
        "el-icon-third-budaidise",
        "el-icon-third-decoration_fill",
        "el-icon-third-shake",
        "el-icon-third-marketing_fill",
        "el-icon-third-financial_fill",
        "el-icon-third-wangwang",
        "el-icon-third-unfold",
        "el-icon-third-packup",
        "el-icon-third-transaction_fill",
        "el-icon-third-shop_fill",
        "el-icon-third-publishgoods_fill",
        "el-icon-third-qianniu",
        "el-icon-third-searchfill",
        "el-icon-third-search",
        "el-icon-third-workbench",
        "el-icon-third-workbench_fill",
        "el-icon-third-warning",
        "el-icon-third-warning_fill",
        "el-icon-third-video_fill",
        "el-icon-third-video",
        "el-icon-third-unlock",
        "el-icon-third-unlock_fill",
        "el-icon-third-undo",
        "el-icon-third-trash_fill",
        "el-icon-third-trash",
        "el-icon-third-translation",
        "el-icon-third-translation_fill",
        "el-icon-third-time",
        "el-icon-third-time_fill",
        "el-icon-third-text",
        "el-icon-third-tasklist",
        "el-icon-third-tasklist_fill",
        "el-icon-third-task_fill",
        "el-icon-third-task",
        "el-icon-third-tailor",
        "el-icon-third-systemprompt",
        "el-icon-third-systemprompt_fill",
        "el-icon-third-switch",
        "el-icon-third-suspend",
        "el-icon-third-success",
        "el-icon-third-success_fill",
        "el-icon-third-stealth",
        "el-icon-third-stealth_fill",
        "el-icon-third-smallscreen",
        "el-icon-third-smallscreen_fill",
        "el-icon-third-shielding",
        "el-icon-third-shielding_fill",
        "el-icon-third-share",
        "el-icon-third-share_fill",
        "el-icon-third-setup",
        "el-icon-third-setup_fill",
        "el-icon-third-service",
        "el-icon-third-service_fill",
        "el-icon-third-send",
        "el-icon-third-select",
        "el-icon-third-select_fill",
        "el-icon-third-scan",
        "el-icon-third-right",
        "el-icon-third-return",
        "el-icon-third-remind",
        "el-icon-third-remind_fill",
        "el-icon-third-refresh",
        "el-icon-third-redpacket",
        "el-icon-third-redpacket_fill",
        "el-icon-third-qrcode",
        "el-icon-third-qrcode_fill",
        "el-icon-third-prompt",
        "el-icon-third-prompt_fill",
        "el-icon-third-praise",
        "el-icon-third-praise_fill",
        "el-icon-third-playon",
        "el-icon-third-playon_fill",
        "el-icon-third-play_fill",
        "el-icon-third-play",
        "el-icon-third-picture",
        "el-icon-third-picture_fill",
        "el-icon-third-people",
        "el-icon-third-people_fill",
        "el-icon-third-other",
        "el-icon-third-order",
        "el-icon-third-order_fill",
        "el-icon-third-offline",
        "el-icon-third-offline_fill",
        "el-icon-third-narrow",
        "el-icon-third-more",
        "el-icon-third-mobilephone",
        "el-icon-third-mobilephone_fill",
        "el-icon-third-mine_fill",
        "el-icon-third-mine",
        "el-icon-third-message_fill",
        "el-icon-third-message",
        "el-icon-third-manage",
        "el-icon-third-manage_fill",
        "el-icon-third-mail_fill",
        "el-icon-third-mail",
        "el-icon-third-lock",
        "el-icon-third-lock_fill",
        "el-icon-third-live",
        "el-icon-third-live_fill",
        "el-icon-third-like",
        "el-icon-third-like_fill",
        "el-icon-third-label_fill",
        "el-icon-third-label",
        "el-icon-third-keyboard",
        "el-icon-third-interactive",
        "el-icon-third-interactive_fill",
        "el-icon-third-integral",
        "el-icon-third-integral_fill",
        "el-icon-third-homepage",
        "el-icon-third-homepage_fill",
        "el-icon-third-headlines",
        "el-icon-third-headlines_fill",
        "el-icon-third-group_fill",
        "el-icon-third-group",
        "el-icon-third-fullscreen",
        "el-icon-third-flip_fill",
        "el-icon-third-flip",
        "el-icon-third-flashlight_fill",
        "el-icon-third-flashlight",
        "el-icon-third-flag",
        "el-icon-third-flag_fill",
        "el-icon-third-feedback",
        "el-icon-third-feedback_fill",
        "el-icon-third-enterinto_fill",
        "el-icon-third-enterinto",
        "el-icon-third-enter",
        "el-icon-third-empty_fill",
        "el-icon-third-empty",
        "el-icon-third-emoji",
        "el-icon-third-emoji_fill",
        "el-icon-third-eit",
        "el-icon-third-editor",
        "el-icon-third-dynamic",
        "el-icon-third-dynamic_fill",
        "el-icon-third-document_fill",
        "el-icon-third-document",
        "el-icon-third-delete",
        "el-icon-third-delete_fill",
        "el-icon-third-customerservice",
        "el-icon-third-customerservice_fill",
        "el-icon-third-createtask",
        "el-icon-third-createtask_fill",
        "el-icon-third-coupons",
        "el-icon-third-coupons_fill",
        "el-icon-third-coordinates",
        "el-icon-third-coordinates_fill",
        "el-icon-third-computer",
        "el-icon-third-computer_fill",
        "el-icon-third-collection",
        "el-icon-third-collection_fill",
        "el-icon-third-close",
        "el-icon-third-clock",
        "el-icon-third-clock_fill",
        "el-icon-third-camera",
        "el-icon-third-camera_fill",
        "el-icon-third-businesscard",
        "el-icon-third-businesscard_fill",
        "el-icon-third-brush_fill",
        "el-icon-third-brush",
        "el-icon-third-browse",
        "el-icon-third-browse_fill",
        "el-icon-third-barrage",
        "el-icon-third-barrage_fill",
        "el-icon-third-addressbook",
        "el-icon-third-addressbook_fill",
        "el-icon-third-addpeople",
        "el-icon-third-addpeople_fill",
        "el-icon-third-addition",
        "el-icon-third-addition_fill",
        "el-icon-third-add",
        "el-icon-third-activity_fill",
        "el-icon-third-activity",
        "el-icon-third-accessory",
      ],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc",
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        parentId: 0,
        name: "",
        function: "",
        url: "",
      },
      styles: {
        width: "300px",
      },
      selectParams: {
        clearable: true,
        placeholder: "请选择资源",
      },
      treeParams: [],
      treeParamsProps: {
        value: "id",
        label: "name",
        children: "resources",
        checkStrictly: true,
        expandTrigger: "hover",
        emitPath: false,
      },
      addForm: {
        parentId: "",
        module: "",
        name: "",
        functions: "",
        url: "",
        icon: "",
        sequence: "",
      },
      addFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入父级资源id",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "父级资源id格式不正确",
          },
        ],
        module: [
          {
            required: true,
            message: "请输入模块",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "模块长度在1到32个字",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入资源名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "资源名称长度在1到32个字",
          },
        ],
        functions: [
          {
            required: true,
            message: "请输入功能",
            trigger: "change",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入资源路径",
            trigger: "blur",
          },
          {
            min: 1,
            max: 512,
            message: "资源路径长度在1到512个字",
          },
        ],
        icon: [
          {
            required: true,
            message: "请输入图标",
            trigger: "blur",
          },
          {
            min: 1,
            max: 48,
            message: "图标长度在1到48个字",
          },
        ],
        sequence: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确",
          },
        ],
      },
      editForm: {
        parentId: "",
        module: "",
        name: "",
        functions: "",
        url: "",
        icon: "",
        sequence: "",
      },
      editFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入父级资源id",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "父级资源id格式不正确",
          },
        ],
        module: [
          {
            required: true,
            message: "请输入模块",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "模块长度在1到32个字",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入资源名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "资源名称长度在1到32个字",
          },
        ],
        functions: [
          {
            required: true,
            message: "请输入功能",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "功能长度在1到32个字",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入资源路径",
            trigger: "blur",
          },
          {
            min: 1,
            max: 512,
            message: "资源路径长度在1到512个字",
          },
        ],
        icon: [
          {
            required: true,
            message: "请输入图标",
            trigger: "blur",
          },
          {
            min: 1,
            max: 48,
            message: "图标长度在1到48个字",
          },
        ],
        sequence: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/resource/upload`,
      fileList: [],
      loading: false,

      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      functions: ["菜单", "页面", "按钮"],
      // functions: ['菜单', '页面', '接口', '新增', '编辑', '删除', '批量删除', '搜索', '重置', '树', '获取详情', '获取集合', '导入', '导出', '立即执行', '恢复', '暂停', '文件配置', '生成文件', '规则配置']
    };
  },
  methods: {
    addBtn () {
      this.addForm.parentId = this.searchForm.parentId;
      this.addFormVisible = true;
    },
    changePid (val) {
      this.page.pageNumber = 1;
      this.searchForm.parentId = val;
      this.pageList();
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getResource () {
      this.api.resource
        .getResource({ id: this.selection })
        .then((result) => {
          this.editForm = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList () {
      this.getResourceTree();
      this.tableLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      if (this.searchForm.parentId == undefined) {
        this.searchForm.parentId = 0;
      }
      this.api.resource
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false;
        })
        .catch((error) => {
          this.tableLoading = false;
          console.log(error);
        });
    },
    addResource () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.module = this.$refs.elAddCascader.inputValue;
          this.api.resource
            .addResource(this.addForm)
            .then((result) => {
              this.addFormVisible = false;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateResource () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.module = this.$refs.elEditCascader.inputValue;
          this.api.resource
            .updateResource(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteResource (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.resource
            .deleteResource([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteResource () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.resource
            .deleteResource(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.resource
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData () {
      this.api.resource
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getResourceTree () {
      this.api.resource
        .getResourceTree()
        .then((result) => {
          this.treeParams = [
            {
              id: 0,
              name: "全部",
              resources: result.data,
            },
          ];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectAddFormModule (data, node, vm) {
      this.addForm.module = node.label;
    },
    selectEditFormModule (data, node, vm) {
      this.editForm.module = node.label;
    },
    selectIcon (form, event) {
      let el = event.currentTarget;
      if (form == "add") {
        this.addForm.icon = el.className;
      } else {
        this.editForm.icon = el.className;
      }
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getResource();
      }
    },
  },
  mounted () {
    this.pageList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/resource/index.vue